import React from 'react'
import styled from 'styled-components'
import AppLayout from '~/components/appLayout'
import OptionsMenu from './menu.component'
import Logo from '~/meta/logo.svg'
import { colors } from '~/design'
import useMedia from 'react-use/lib/useMedia'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`

export default function OptionsScreen() {
  return (
    <AppLayout
      title='Opções'
      initialMenuVisibility={true}
      dockActive='options'
      menu={<OptionsMenu />}
    >
      <Wrapper>
        <Logo width={250} height={250} fill={colors.sebraeBlue} />
      </Wrapper>
    </AppLayout>
  )
}
